import agartha from "public/images/agartha.jpg";
import tourney from "public/images/tourney.png";

import { DoomLayoutSection, H3, Line, P, useBreakpoints } from "@sorcery/ui";

export const BecomeARetailerPoliciesTab = () => {
  const { isLg } = useBreakpoints();
  return (
    <div className="duration-1000 animate-in fade-in">
      <DoomLayoutSection
        bg={agartha}
        darken={!isLg}
        gradient={false}
        tight={true}
        smooshRight={isLg}
        className="mb-20 gradient-mask-b-90 sm:mb-8"
        left={
          <div className="w-full sm:my-16">
            <H3 className="!mb-4 text-center !text-2xl text-big-text-color sm:mt-0 sm:text-left">
              MAP Policy
            </H3>
            <Line className="mb-1" />
            <Line className="mb-4" />
          </div>
        }
        right={<div className="h-28" />}
      />

      <div className="mb-12">
        <P>
          <strong className="mb-2 block underline">Who does this policy apply to?</strong>
          <span>
            This policy applies to Sorcery: Contested Realm products sold through retailers (online
            and brick and mortar) who are based and operate in the United States of America or
            Canada.
          </span>
        </P>
      </div>

      <div className="mb-12">
        <P>
          <strong className="mb-2 block underline">Why do we have a MAP Policy?</strong>

          <span>
            In order to support an even playing field for retailers, we have set a Minimum
            Advertised Price (MAP) for Sorcery: Contested Realm booster box products.
          </span>
        </P>
        <P>
          We recognize that many stores and retailers put effort and resources into supporting
          Sorcery: Contested Realm communities by fostering a fun and engaging space to play the
          game.
        </P>
        <P>
          One of our objectives is to ensure that those retailers who put in this effort, and
          consequentially assist in growing demand for the game, are not disadvantaged by unfair
          pricing conduct by other retailers who may not make the same investments in supporting the
          game.
        </P>
      </div>

      <div className="mb-12">
        <P>
          <strong className="mb-2 block underline">
            Which Sorcery: Contested Realm products are covered?
          </strong>

          <span>
            Below we have listed the products that are covered by this MAP Policy, and the relevant
            Manufacturer Suggested Retail Price (MSRP) and MAP for each product.
          </span>
        </P>

        <table className="w-full border border-line-color">
          <thead>
            <tr className="border-b border-line-color">
              <th className="w-1/2 p-3 text-left">Product Name</th>
              <th className="p-3 text-left">SKU</th>
              <th className="w-1/6 p-3 text-left">MSRP ($USD)</th>
              <th className="w-1/6 p-3 text-left">MAP ($USD)</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-line-color">
              <td className="p-3">Beta Booster Box</td>
              <td className="p-3">SCRB2</td>
              <td className="p-3">$150</td>
              <td className="p-3">$120</td>
            </tr>
            <tr>
              <td className="p-3">Arthurian Legends Booster Box</td>
              <td className="p-3">SCRAL</td>
              <td className="p-3">$129</td>
              <td className="p-3">$116.10</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="mb-12">
        <P>
          <strong className="mb-2 block underline">What must retailers do to comply?</strong>

          <span>
            The price at which retailers advertise products covered by this policy for sale to
            customers must not be below the MAP for that product. We consider retailers advertise
            products if they include them in:
          </span>
        </P>

        <ul className="mb-4 ml-10 list-outside list-disc">
          <li>
            Online media such as websites, social media posts, online stores, and online auction
            sites with fixed price auctions (including offering ‘best offer’ below MAP)
          </li>
          <li>Online or in-person auctions without a reserve</li>
          <li>Third-party websites</li>
          <li>
            Magazines, newspapers, periodicals, catalogs, or other online or traditional media
          </li>
        </ul>

        <P>
          This policy does not prevent retailers from setting prices at the point of sale, it
          applies to the price for which retailers advertise products which are covered by this
          policy.
        </P>
      </div>

      <div className="mb-12">
        <P>
          <strong className="mb-2 block underline">Effect of breaking MAP</strong>

          <span>
            If retailers breach or contravene this MAP policy, we will request the retailer remedy
            the breach and restore compliance within a reasonable period (for example 1-2 business
            days).
          </span>
        </P>

        <P>
          <span>
            If retailers continue to breach the policy beyond the period specified in our request,
            we may take actions including (but not limited to):
          </span>
        </P>

        <ul className="mb-4 ml-10 list-outside list-disc">
          <li>Suspending or ceasing supply of Sorcery: Contested Realm products to the retailer</li>
          <li>Suspending or removing the store and events from the Sorcery Play Network</li>
          <li>Suspending or removing the store from the Sorcery Event Locator</li>
        </ul>
      </div>

      <div className="mb-12">
        <P>
          <strong className="mb-2 block underline">Frequently asked questions</strong>
        </P>

        <P>Does MAP apply to multiple booster boxes being sold together?</P>

        <P className="sorcery-quote">
          Yes. Divide the total sale price of the booster box bundle (whether a case or other number
          of boxes) by the total sale price to calculate the price per box. The price per box must
          not be below MAP.
        </P>

        <P>If I’m a retailer outside the USA or Canada, am I bound by this policy?</P>

        <P className="sorcery-quote">No</P>

        <P>
          If I post on my store Facebook page that I am offering a 1-day special price on Sorcery:
          Contested Realm booster boxes that would take the price below MAP, will that breach this
          policy?
        </P>

        <P className="sorcery-quote">
          Yes. Retailers covered by the policy who advertise products covered by this policy for
          sale below MAP via social media, even if the price is only temporary, will be in breach of
          this policy.
        </P>

        <P>
          If I advertise Sorcery: Contested Realm products for sale on my online store at MAP, then
          offer a discount that applies to all TCG booster boxes that brings the price of Sorcery:
          Contested Realm booster boxes below MAP, will that breach this policy?
        </P>

        <P className="sorcery-quote">
          Yes, if the discount is advertised to customers as applying to Sorcery: Contested Realm
          products covered by this policy, whether directly or by reference to a category (such as
          “all TCG booster boxes”) which includes those products.
        </P>
      </div>
      <Line className="my-16" />

      <DoomLayoutSection
        bg={tourney}
        darken={!isLg}
        gradient={false}
        tight={true}
        smooshRight={isLg}
        className="mb-20 gradient-mask-b-90 sm:mb-8"
        left={
          <div className="w-full sm:my-16">
            <H3 className="!mb-4 text-center !text-2xl text-big-text-color sm:mt-0 sm:text-left">
              Promotional Materials Policy
            </H3>
            <Line className="mb-1" />
            <Line className="mb-4" />
          </div>
        }
        right={<div className="h-28" />}
      />

      <div className="mb-12">
        <P>
          <strong className="mb-2 block underline">Background</strong>
          <span>
            <span>
              Erik’s Curiosa provides promotional materials to stores and event organizers to
              support players’ enjoyment of
            </span>{" "}
            <em>Sorcery: Contested Realm </em>
            <span>and foster community growth.</span>
          </span>
        </P>
        <P>
          This policy sets out Erik’s Curiosa’s expectations about use of these promotional
          materials and the consequences where stores and individuals fall short of those
          expectations.
        </P>
        <P>
          Erik’s Curiosa’s objective is to foster an environment where promotional materials enhance
          players’ experience of the game and are distributed in a fair, responsible way.
        </P>
      </div>

      <div className="mb-12">
        <P>
          <strong className="mb-2 block underline">Coverage of this policy</strong>

          <span>
            <span>
              This policy applies to the following promotional materials which Erik’s Curiosa
              distributes to&nbsp;
            </span>
            <strong>stores</strong>
            <span>&nbsp;and&nbsp;</span>
            <strong>tournament organizers:</strong>
          </span>
        </P>

        <table className="mb-4 w-full border border-line-color">
          <thead>
            <tr className="border-b border-line-color">
              <th className="p-3 text-left">Product Name</th>
              <th className="p-3 text-left">SKU</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-line-color">
              <td className="p-3">Store Kit 1</td>
              <td className="p-3">SCRB6</td>
            </tr>
            <tr className="border-b border-line-color">
              <td className="p-3">Store Kit 1b</td>
              <td className="p-3">SCRSK1B</td>
            </tr>
            <tr>
              <td className="p-3">Store Kit 2</td>

              <td className="p-3">SCRSK2</td>
            </tr>
          </tbody>
        </table>

        <P>
          <span>(the&nbsp;</span>
          <strong>Promotional Materials</strong>
          <span>)</span>
        </P>

        <P>
          This policy applies to the way in which stores and tournament organizers use Promotional
          Materials as a whole and the components (e.g. cards, playmats and other components) within
          the Promotional Materials. References to Promotional Materials in this policy includes
          components of Promotional Materials unless otherwise stated.
        </P>

        <P>
          Once players receive Promotional Materials from stores and tournament organisers in
          accordance with this policy, players are free to deal with those Promotional Materials as
          they wish.
        </P>
      </div>

      <div className="mb-12">
        <P>
          <strong className="mb-2 block underline">
            Requirements for distribution of promotional materials
          </strong>

          <span>
            Stores and tournament organizers who receive Promotional Materials must distribute them
            to players and community members in their stores as prizes in Sorcery: Contested Realm
            tournaments, leagues, or other play events.
          </span>
        </P>

        <P>
          Stores may charge entry fees for these tournaments, and may distribute the Promotional
          Materials in a manner of their choosing to attendees, so long as that distribution is fair
          and reasonable.
        </P>
        <P>
          Distribution of Promotional Materials must not involve players paying money to the store
          directly for particular Promotional Materials.
        </P>
        <P>
          Promotional Materials may be distributed to players, for example, through the following
          prize methods:
        </P>

        <ul className="mb-4 ml-10 list-outside list-disc">
          <li>Prizes for placement in ticketed tournaments (e.g. first place, second place)</li>
          <li>
            Random draw prizes in ticketed tournaments (where players do not pay additional funds
            for additional chances at prizes)
          </li>
          <li>Participation prizes in ticketed tournaments</li>
          <li>Participation prizes in learn-to-play events</li>
          <li>Rewards for learn-to-play guides or participants</li>
          <li>Other similar methods of distribution.</li>
        </ul>

        <P>
          Stores and tournament organizers must not sell Promotional Materials in person, online,
          via auction sites or through direct sale. This includes exchanging or trading promotional
          materials for other goods (such as product, singles or other goods provided as
          consideration in-kind).
        </P>
      </div>

      <div className="mb-12">
        <P>
          <strong className="mb-2 block underline">Consequences of breach of this policy</strong>

          <span>
            If stores or tournament organizers use Promotional Materials in a manner contrary to the
            requirements of this policy, Erik’s Curiosa reserves the right to take disciplinary
            action, including temporary suspension or permanent bans from:
          </span>
        </P>

        <ul className="mb-4 ml-10 list-outside list-disc">
          <li>access to Promotional Materials</li>
          <li>use of the Sorcery Play Network, or</li>
          <li>
            <span>access to&nbsp;</span>
            <em>Sorcery: Contested Realm</em>
            <span>&nbsp;product.</span>
          </li>
        </ul>

        <P>
          We have created this policy to do our best to ensure these Promotional Materials, which we
          produce for players to enjoy, are distributed fairly and equitably and in good faith.
        </P>

        <P>
          Thank you to all of the stores and tournament organizers building Sorcery: Contested Realm
          play communities around the world!
        </P>
      </div>
    </div>
  );
};
